import React from "react";
import { Avatar, Grid, Text } from "@pushpress/shared-components";
import { CalendarItemAttendeeFragment } from "../CalendarDetail-generated.hooks";
import { capitalizeFirstLetter } from "../../../../utils/misc";

interface AttendeeAvatarNameColumnProps {
  attendee: CalendarItemAttendeeFragment;
}

function AttendeeAvatarNameColumn({ attendee }: AttendeeAvatarNameColumnProps) {
  const splittedName = attendee.customerName
    .split(" ")
    .filter(Boolean)
    .map((item) => item![0])
    .join("");

  return (
    <Grid container alignItems="center" spacing={2} wrap="nowrap">
      <Grid item>
        <Avatar size="medium">
          {attendee.primaryImage ? (
            <img
              src={attendee.primaryImage}
              alt={`${attendee.customerName} avatar`}
            />
          ) : (
            splittedName
          )}
        </Avatar>
      </Grid>
      <Grid item>
        <Text variant="body-lg" color="wolf-800">
          {attendee.customerName}
        </Text>
        <Text variant="body-lg" color="wolf-600">
          {capitalizeFirstLetter(attendee.membershipRole)}
        </Text>
      </Grid>
    </Grid>
  );
}

export default AttendeeAvatarNameColumn;
